import React from 'react';
import PropTypes from 'prop-types';

import { StaffContainer, LocationText, StyledLocationContainer } from './style';

const formatStatisticValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string' && value.trim() === '') {
    return value;
  }

  const number = Number(value);

  if (Number.isNaN(number)) {
    return value;
  }

  return Number.isInteger(number)
    ? number.toLocaleString()
    : number.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

const LocationInfo = ({ statistics }) => (
  <StaffContainer>
    {statistics.map(({ name, value }) => (
      <StyledLocationContainer key={`${name}_${value}`}>
        <LocationText>
          <strong>{name}</strong>
        </LocationText>
        <LocationText>{formatStatisticValue(value)}</LocationText>
      </StyledLocationContainer>
    ))}
  </StaffContainer>
);

LocationInfo.propTypes = {
  statistics: PropTypes.array.isRequired,
};

export default LocationInfo;
